import { render, staticRenderFns } from "./manage-presets-table.vue?vue&type=template&id=21390f26"
import script from "./manage-presets-table.vue?vue&type=script&lang=js"
export * from "./manage-presets-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports